(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customfaq"] && !Shopify.designMode) return;
  try {
    
(function(){
  // Optional: open/close one-at-a-time per chapter
  const root = document.getElementById('faq-{{ section.id }}');
  if(!root) return;
  root.querySelectorAll('.qa-list').forEach(list=>{
    list.addEventListener('toggle', (e)=>{
      const tgt = e.target;
      if(!(tgt instanceof HTMLDetailsElement) || !tgt.open) return;
      list.querySelectorAll('details.qa[open]').forEach(d=>{
        if(d !== tgt) d.open = false;
      });
    }, true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }
      reset() {
        const isLarge = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLarge &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);
        this.disclosure.open = isLarge || isConfirmNewsletter;
        if (isLarge) this.toggle.setAttribute('tabindex', '-1'); else this.toggle.removeAttribute('tabindex');
      }
    }
    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
